/**
 * Message compound component. The assembly (MessageContext, sub-components,
 * statics) and the Tailwind-vs-styled-components routing live in MessageHybrid.
 * This file re-exports the assembled compound so the public surface (default
 * export + attached statics/sub-components) is unchanged.
 */

import Message from "./MessageHybrid";

export default Message;
